import { render } from "./HelsinkiMetsLogo.vue?vue&type=template&id=be71f438"
const script = {}

import "./HelsinkiMetsLogo.vue?vue&type=style&index=0&id=be71f438&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__